import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';

import css from './index.module.scss';

type RelatedQuestionProps = {
  relatedQuestions: string[];
};

const RelatedQuestions = ({ relatedQuestions }: RelatedQuestionProps) => {
  const { t } = useTranslation();
  return (
    <Box direction="vertical" gap={1}>
      <Text size="small" weight="normal">{t('article-page.copilot.related-questions.title')}</Text>
      <Box direction="vertical">
        {relatedQuestions.map((relatedQuestion) => (
          <Text size="tiny" className={css.relatedQuestion} key={relatedQuestion} weight="thin" skin="primary">{
            relatedQuestion}
          </Text>
        ))}
      </Box>
    </Box>
  );
};

export default RelatedQuestions;
